"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var workflow_1 = require("../../../../../../../../reducers/slices/workflow/workflow");
var node_1 = __importDefault(require("../../node"));
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var constants_1 = require("../../../constants");
var react_2 = require("@nextui-org/react");
var EventNode = function (props) {
    var data = props.data;
    var dispatch = (0, react_redux_1.useDispatch)();
    var setNodeData = function (data) {
        dispatch((0, workflow_1.setNode)(__assign(__assign({}, props), { data: data })));
    };
    var statutsComparisonOptions = [
        { label: "Equals", value: "equals" },
        { label: "Does Not Equal", value: "not_equals" },
    ];
    var configurationComponent = function (data) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var _j = (_b = (_a = data === null || data === void 0 ? void 0 : data.config) === null || _a === void 0 ? void 0 : _a.topic) === null || _b === void 0 ? void 0 : _b.split("/"), model = _j[0], topic = _j[1];
        var options = (_c = constants_1.workflowEventStatusOptions[model]) !== null && _c !== void 0 ? _c : [];
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: topic === "status-change" ? ((0, jsx_runtime_1.jsx)(react_2.Select, __assign({ label: "When Status changes to:", selectedKeys: ((_d = data === null || data === void 0 ? void 0 : data.config) === null || _d === void 0 ? void 0 : _d.status) ? [data.config.status] : [], onSelectionChange: function (keys) {
                    var selectedStatus = Array.from(keys)[0];
                    setNodeData(__assign(__assign({}, data), { config: __assign(__assign({}, data.config), { status: selectedStatus }) }));
                }, classNames: {
                    trigger: "border-borders",
                } }, { children: options.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_2.SelectItem, { children: option.label }, option.value)); }) }))) : ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsx)(react_2.Select, __assign({ label: "When Status", size: "sm", placeholder: "Select comparison", selectedKeys: [(_f = (_e = data === null || data === void 0 ? void 0 : data.config) === null || _e === void 0 ? void 0 : _e.comparison) !== null && _f !== void 0 ? _f : "equals"], onSelectionChange: function (keys) {
                            var selectedComparison = Array.from(keys)[0];
                            setNodeData(__assign(__assign({}, data), { config: __assign(__assign({}, data.config), { comparison: selectedComparison }) }));
                        }, classNames: {
                            trigger: "border-borders",
                        } }, { children: statutsComparisonOptions.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_2.SelectItem, __assign({ value: option.value }, { children: option.label }), option.value)); }) })), (0, jsx_runtime_1.jsx)(react_2.Select, __assign({ label: "Status", size: "sm", placeholder: "ANY", selectedKeys: [(_h = (_g = data === null || data === void 0 ? void 0 : data.config) === null || _g === void 0 ? void 0 : _g.status) !== null && _h !== void 0 ? _h : ""], onChange: function (e) {
                            var selectedStatus = e.target.value === null ? "" : e.target.value;
                            setNodeData(__assign(__assign({}, data), { config: __assign(__assign({}, data.config), { status: selectedStatus }) }));
                        }, classNames: {
                            trigger: "border-borders",
                        } }, { children: options.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_2.SelectItem, __assign({ value: option.value }, { children: option.label }), option.value)); }) }))] }))) }));
    };
    return ((0, jsx_runtime_1.jsx)(node_1.default, __assign({ category: "event", icon: pro_light_svg_icons_1.faBolt, data: data }, props, { configurationComponent: configurationComponent })));
};
exports.default = (0, react_1.memo)(EventNode);
